module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-coupon-procedure.654b4c1f.png";